export const literature = [
  {
    id: 0,
    link: 'https://www.helsinki.org.ua/wp-content/uploads/2021/09/MGP_4_3.pdf',
    titleText: 'ВИВЧАЮЧИ МІЖНАРОДНЕ ГУМАНІТАРНЕ ПРАВО (UA)',
  },
  {
    id: 1,
    link: 'https://www.asser.nl/media/795044/icrc-comprehensive-introduction-to-ihl-ukr.pdf',
    titleText: 'БАЗОВИЙ ПІДРУЧНИК З МГП Н.МЕЛЬЦЕРА (UA)',
  },
  {
    id: 2,
    link: 'https://www.helsinki.org.ua/wp-content/uploads/2018/03/MHP-final.pdf',
    titleText: 'МІЖНАРОДНЕ ГУМАНІТАРНЕ ПРАВО (UA)',
  },
  {
    id: 3,
    link: 'https://shop.icrc.org/international-humanitarian-law-a-comprehensive-introduction-pdf-ru-1.html',
    titleText: 'БАЗОВИЙ ПІДРУЧНИК З МГП Н.МЕЛЬЦЕРА (EN/RU)',
  },
  {
    id: 4,
    link: 'https://ihl-databases.icrc.org/en/customary-ihl/v1',
    titleText: 'ЗВИЧАЄВІ НОРМИ МГП З КОМЕНТАРЯМИ (EN/RU)',
  },
  {
    id: 5,
    link: 'https://blogs.icrc.org/ua/wp-content/uploads/sites/98/2021/12/IHL_Answers_to_your_questions_Ukr_web.pdf',
    titleText: 'ICRC. МГП: ВІДПОВІДАЮЧИ НА ЗАПИТАННЯ (UA)',
  },
  {
    id: 6,
    link: 'https://www.icrc.org/en/doc/assets/files/other/icrc-002-0703.pdf',
    titleText: 'ICRC. IHL: ANSWERS TO YOUR QUESTIONS (EN/RU)',
  },
  {
    id: 7,
    link: 'https://www.icrc.org/en/doc/assets/files/other/icrc-002-0990.pdf',
    titleText:
      'INTERPRETIVE GUIDANCE ON THE NOTION OF DIRECT PARTICIPATION IN HOSTILITIES UNDER INTERNATIONAL HUMANITARIAN LAW (EN)',
  },
  {
    id: 8,
    link: 'https://www.icrc.org/ru/download/file/40140/dph_rus_web.pdf',
    titleText:
      'ТЛУМАЧНІ ВКАЗІВКИ ЩОДО ПОНЯТТЯ ПРЯМОЇ УЧАСТІ У БОЙОВИХ ДІЯХ ЗГІДНО З МІЖНАРОДНИМ ГУМАНІТАРНИМ ПРАВОМ (RU)',
  },
  {
    id: 9,
    link: 'https://www.icrc.org/en/document/ihl-digital-app',
    titleText:
      'IHL APP 2.0: INTERNATIONAL HUMANITARIAN LAW AND MORE IN YOUR POCKET (EN/RU)',
  },
];

export const videosMocks = [
  {
    id: 0,
    subtitleText: 'Module 1',
    titleText: 'What is IHL?/Introduction to LOAC',
    videoImage: 'https://www.w3schools.com/html/pic_trulli.jpg',
    wasSeenCount: 3200,
  },
  {
    id: 1,
    subtitleText: 'Module 2',
    titleText: 'Principle of Distinction',
    videoImage: 'https://www.w3schools.com/html/pic_trulli.jpg',
    wasSeenCount: 3200,
  },
  {
    id: 2,
    subtitleText: 'Module 3',
    titleText: 'Protected Persons and Objects',
    videoImage: 'https://www.w3schools.com/html/pic_trulli.jpg',
    wasSeenCount: 3200,
  },
  {
    id: 3,
    subtitleText: 'Module 4',
    titleText: 'Behaviour in Combat',
    videoImage: 'https://www.w3schools.com/html/pic_trulli.jpg',
    wasSeenCount: 3200,
  },
  {
    id: 4,
    subtitleText: 'Module 5',
    titleText: 'Means and Methods of Warfare',
    videoImage: 'https://www.w3schools.com/html/pic_trulli.jpg',
    wasSeenCount: 3200,
  },
];
